import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  {
    key: "towels",
    title: "Towels",
    note: "Terry, velour & jacquard — hotel and retail grades",
    img: "https://images.unsplash.com/photo-1638232928539-6e91c47ddec5?q=80&w=1600&auto=format&fit=crop",
    span: "md:col-span-7",
    height: "h-[380px] sm:h-[480px]",
  },
  {
    key: "bathrobes",
    title: "Bathrobes",
    note: "Spa-weight waffle and plush terry silhouettes",
    img: "https://images.unsplash.com/photo-1780571525506-67e3bb9ca947?q=80&w=1600&auto=format&fit=crop",
    span: "md:col-span-5",
    height: "h-[380px] sm:h-[480px]",
  },
  {
    key: "peshtemals",
    title: "Peshtemals",
    note: "Flat-woven hamam towels with hand-knotted fringes",
    img: "https://images.unsplash.com/photo-1588610992315-5654831ceebd?q=80&w=1600&auto=format&fit=crop",
    span: "md:col-span-5",
    height: "h-[380px] sm:h-[440px]",
  },
  {
    key: "home-textiles",
    title: "Home Textiles",
    note: "Throws, blankets and bed collections",
    img: "https://images.unsplash.com/photo-1608424371207-ab70d9d68e80?q=80&w=1600&auto=format&fit=crop",
    span: "md:col-span-7",
    height: "h-[380px] sm:h-[440px]",
  },
];

export default function Products() {
  return (
    <section id="collection" data-testid="products-section" className="py-24 sm:py-32 border-t border-line">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.3em] font-semibold text-clay mb-6">
                02 — The Collection
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
                Four crafts,
                <em className="italic text-clay"> one loom.</em>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-smoke text-sm sm:text-base max-w-xs leading-relaxed">
              Every category is produced in-house and finished for private
              label — from yarn to packaging.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.key} delay={0.08 * (i % 2)} className={`${p.span} group`}>
              <div data-testid={`product-card-${p.key}`} className="relative overflow-hidden bg-night">
                <img
                  src={p.img}
                  alt={p.title}
                  className={`w-full ${p.height} object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-[transform,opacity] duration-700 ease-out`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#121212]/70 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 flex items-end justify-between">
                  <div>
                    <p className="text-cream/60 text-[10px] uppercase tracking-[0.3em] mb-2">
                      {String(i + 1).padStart(2, "0")}
                    </p>
                    <h3 className="font-serif text-cream text-3xl sm:text-4xl font-light">{p.title}</h3>
                    <p className="text-cream/70 text-xs sm:text-sm mt-2 max-w-[260px]">{p.note}</p>
                  </div>
                  <span className="shrink-0 w-11 h-11 border border-cream/40 flex items-center justify-center text-cream group-hover:bg-cream group-hover:text-ink transition-colors duration-300">
                    <ArrowUpRight size={16} />
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
